import React from 'react';
import { components, OptionProps } from 'react-select';
import cn from 'classnames';

import Tooltip from '@components/common/Tooltip';

import { Icons } from '@icons/icons';

import { TSelectOptionType } from '@components/common/Select/Select.types';

import colors from '@constants/colors';

export const OptionFavorite = (
	props: OptionProps & { data: { isDefault?: boolean } },
	onFavoriteClick?: (data: TSelectOptionType) => void,
	favoriteTooltip?: string,
) => {
	const setFavorite = () => {
		if (props?.isDisabled) {
			return;
		}

		if (onFavoriteClick) {
			onFavoriteClick(props.data as TSelectOptionType);
		}
	};

	return (
		<div className='f5gFavoriteSelectEditButtonsContainer'>
			<components.Option {...props}>{props.label}</components.Option>
			<div
				className={cn('f5gFavoriteSelectEditButtons', {
					selected: props.data?.isDefault,
				})}
			>
				<Tooltip
					content={favoriteTooltip}
					isDisabled={props.data?.isDefault || !!props.isDisabled}
					placement='top-end'
				>
					<div onClick={setFavorite}>
						{Icons.star({ color: props.data?.isDefault ? colors.white : colors.indigo70 })}
					</div>
				</Tooltip>
			</div>
		</div>
	);
};
